const MODAL_PREFIX = '@MODAL';

export const SHOW = `${MODAL_PREFIX}/SHOW`;
export const HIDE = `${MODAL_PREFIX}/HIDE`;
